import { fetchJson, patchJson, postJson, uploadRawBytes } from '../client';

/**
 * `/api/me/*` endpoint clients.
 *
 * DTOs are kept hand-rolled here despite the `@fiszki/shared-contracts` codegen (T26): the
 * generated types collapse string enums to `string` and mark every property as optional, which
 * loses load-bearing precision (`username: string | null`, `locale: 'pl' | 'en'`). The committed
 * `apps/api/openapi.json` documents the wire format; these aliases narrow it for runtime safety.
 */

export type ThemeId = 'alicja' | 'bonus';

export interface BootstrapResponse {
  userId: number;
  auth0Sub: string;
  email: string;
  username: string | null;
  displayName: string;
  role: string;
  premiumStatus: string;
  locale: string;
  /** UI theme — 'alicja' (dark editorial) | 'bonus' (light editorial). Default 'alicja'. */
  theme: ThemeId;
  hasUsername: boolean;
}

export interface MeResponse extends BootstrapResponse {
  avatarUrl: string | null;
  bio: string | null;
  premiumUntil: string | null;
  storageUsedBytes: number;
  status: string;
  createdAt: string;
  updatedAt: string;
}

export interface PatchMeRequest {
  displayName?: string;
  bio?: string;
  locale?: 'pl' | 'en';
  username?: string;
  theme?: ThemeId;
}

export interface UsernameAvailabilityResponse {
  candidate: string;
  normalized: string;
  isAvailable: boolean;
  error: string | null;
}

export interface UploadAvatarResponse {
  avatarUrl: string;
}

export const meApi = {
  bootstrap: () => postJson<BootstrapResponse>('/me/bootstrap'),
  getMe: () => fetchJson<MeResponse>('/me'),
  patchMe: (changes: PatchMeRequest) => patchJson<MeResponse, PatchMeRequest>('/me', changes),
  checkUsername: (candidate: string) =>
    fetchJson<UsernameAvailabilityResponse>(
      `/me/username-availability?candidate=${encodeURIComponent(candidate)}`,
    ),
  uploadAvatar: (file: File | Blob, contentType: string) =>
    uploadRawBytes<UploadAvatarResponse>('/me/avatar', file, contentType),
};
